<!-- <template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <p>
      For a guide and recipes on how to configure / customize this project,<br>
      check out the
      <a href="https://cli.vuejs.org" target="_blank" rel="noopener">vue-cli documentation</a>.
    </p>
    <h3>Installed CLI Plugins</h3>
    <ul>
      <li><a href="https://github.com/vuejs/vue-cli/tree/dev/packages/%40vue/cli-plugin-babel" target="_blank" rel="noopener">babel</a></li>
      <li><a href="https://github.com/vuejs/vue-cli/tree/dev/packages/%40vue/cli-plugin-eslint" target="_blank" rel="noopener">eslint</a></li>
    </ul>
    <h3>Essential Links</h3>
    <ul>
      <li><a href="https://vuejs.org" target="_blank" rel="noopener">Core Docs</a></li>
      <li><a href="https://forum.vuejs.org" target="_blank" rel="noopener">Forum</a></li>
      <li><a href="https://chat.vuejs.org" target="_blank" rel="noopener">Community Chat</a></li>
      <li><a href="https://twitter.com/vuejs" target="_blank" rel="noopener">Twitter</a></li>
      <li><a href="https://news.vuejs.org" target="_blank" rel="noopener">News</a></li>
    </ul>
    <h3>Ecosystem</h3>
    <ul>
      <li><a href="https://router.vuejs.org" target="_blank" rel="noopener">vue-router</a></li>
      <li><a href="https://vuex.vuejs.org" target="_blank" rel="noopener">vuex</a></li>
      <li><a href="https://github.com/vuejs/vue-devtools#vue-devtools" target="_blank" rel="noopener">vue-devtools</a></li>
      <li><a href="https://vue-loader.vuejs.org" target="_blank" rel="noopener">vue-loader</a></li>
      <li><a href="https://github.com/vuejs/awesome-vue" target="_blank" rel="noopener">awesome-vue</a></li>
    </ul>
  </div>
</template> -->

<template>
  <!-- <div class="hello">
    <h1>网站正在建设中...</h1>
  </div>
  <div style="text-align: center; margin-top: 20px;">
    <a href="https://beian.miit.gov.cn" target="_blank">鄂ICP备2023029089号-4</a>
  </div> -->
  <nav class="navbar">
        <div class="logo">WeStats</div>
    </nav>

    <section class="hero">
        <h1>微信加粉精准统计解决方案</h1>
        <p>专业级数据管理工具，解决私域营销痛点</p>
        <a href="https://www.wedidit.top/downloads/微信加粉计数器setup.exe" class="cta-button">立即免费试用</a>
    </section>

    <section class="features">
        <div class="card">
            <i class="icon fas fa-shield-alt"></i>
            <h3>品质保证</h3>
            <p>无木马无后门，通过国际安全认证，保障数据隐私与系统安全</p>
        </div>
        <div class="card">
            <i class="icon fas fa-headset"></i>
            <h3>售后保障</h3>
            <p>7×16小时专业技术支持，快速响应解决使用问题</p>
        </div>
        <div class="card">
            <i class="icon fas fa-cogs"></i>
            <h3>贴心服务</h3>
            <p>支持定制化开发，满足不同业务场景的个性化需求</p>
        </div>
    </section>

    <section class="pain-points">
        <h2 style="text-align: center; margin-bottom: 2rem;">我们解决的痛点</h2>
        <div class="comparison-table">
            <div class="problem">
                <h4>传统统计缺陷</h4>
                <p>企微官方统计需双方互为好友</p>
            </div>
            <div class="solution">
                <h4>我们的方案</h4>
                <p>适用于非企微，私域运营</p>
            </div>

            <div class="problem">
                <h4>多账号管理难题</h4>
                <p>人工核对耗时费力，数据准确性难以保证</p>
            </div>
            <div class="solution">
                <h4>我们的方案</h4>
                <p>智能聚合多账号数据，自动生成可视化报表</p>
            </div>

            <div class="problem">
                <h4>合作信任危机</h4>
                <p>广告主与客户缺乏可信数据平台，纠纷不断</p>
            </div>
            <div class="solution">
                <h4>我们的方案</h4>
                <p>不可篡改的可信数据平台，链接分享，透明可视</p>
            </div>
        </div>
    </section>

    <section class="contact-section" style="padding: 4rem 5%; background: #f8f9fa;">
        <div style="max-width: 1200px; margin: 0 auto;">
            <h2 style="text-align: center; margin-bottom: 2rem; color: var(--dark-blue);">立即咨询</h2>
            <div style="display: flex; justify-content: center; gap: 3rem; flex-wrap: wrap;">
                <div class="qr-code" style="text-align: center;">
                    <div style="background: white; padding: 1rem; border-radius: 10px; box-shadow: 0 5px 15px rgba(0,0,0,0.1);">
                        <img src="@/assets/wechat-qr.png" alt="微信客服" style="width: 180px; height: 180px; margin-bottom: 1rem;">
                        <div style="display: flex; align-items: center; gap: 0.5rem; color: var(--dark-blue);">
                            <i class="fab fa-weixin" style="font-size: 1.2rem;"></i>
                            <p style="margin: 0;">扫码添加客服微信</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <footer style="background: var(--dark-blue); color: white; padding: 2rem 5%; text-align: center;">
        <p>服务时间：每日8:00-24:00 | 邮箱：604878040@qq.com</p>
        <p>© 2025 WeStats 维度信息 保留所有权利</p>
        <a href="https://beian.miit.gov.cn" target="_blank" style="color: white;text-decoration: none;">鄂ICP备2023029089号-4</a>
    </footer>

</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .navbar {
        background: rgba(255, 255, 255, 0.95);
        padding: 1rem 5%;
        position: fixed;
        width: 100%;
        box-shadow: 0 2px 10px rgba(0,0,0,0.1);
        z-index: 1000;
    }

    .logo {
        font-size: 1.8rem;
        color: var(--dark-blue);
        font-weight: bold;
    }

    .hero {
        padding: 120px 5% 80px;
        background: linear-gradient(45deg, var(--primary-color), var(--secondary-color));
        color: white;
        text-align: center;
    }

    .hero h1 {
        font-size: 2.5rem;
        margin-bottom: 1.5rem;
        animation: slideUp 1s ease;
    }

    .features {
        padding: 4rem 5%;
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
        gap: 2rem;
    }

    .card {
        background: white;
        padding: 2rem;
        border-radius: 10px;
        box-shadow: 0 5px 15px rgba(0,0,0,0.1);
        transition: transform 0.3s ease;
    }

    .card:hover {
        transform: translateY(-10px);
    }

    .icon {
        font-size: 2.5rem;
        color: var(--primary-color);
        margin-bottom: 1rem;
    }

    .pain-points {
        background: white;
        padding: 4rem 5%;
    }

    .comparison-table {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 2rem;
        margin-top: 2rem;
    }

    .problem {
        background: #ffe5e5;
        padding: 1.5rem;
        border-radius: 8px;
    }

    .solution {
        background: #e5ffe7;
        padding: 1.5rem;
        border-radius: 8px;
    }

    .cta-button {
        display: inline-block;
        padding: 1rem 2rem;
        background: var(--primary-color);
        color: white;
        border-radius: 30px;
        text-decoration: none;
        margin-top: 2rem;
        transition: background 0.3s ease;
    }

    .cta-button:hover {
        background: var(--dark-blue);
    }

    /* 新增联系版块样式 */
    .contact-section {
        padding: 4rem 5%;
        background: #f8f9fa;
        position: relative;
        overflow: hidden;
    }

    .qr-code {
        transition: transform 0.3s ease;
        cursor: pointer;
        text-align: center;
    }

    .qr-code:hover {
        transform: translateY(-5px);
    }

    .qr-code:hover img {
        animation: pulse 1s ease;
    }

    .contact-info {
        max-width: 400px;
    }

    @keyframes slideUp {
        from { transform: translateY(50px); opacity: 0; }
        to { transform: translateY(0); opacity: 1; }
    }

    @keyframes pulse {
        0% { transform: scale(1); }
        50% { transform: scale(1.05); }
        100% { transform: scale(1); }
    }

    @media (max-width: 768px) {
        .comparison-table {
            grid-template-columns: 1fr;
        }
        .contact-info {
            text-align: center;
            margin-top: 2rem;
        }
    }
</style>
